document.addEventListener('DOMContentLoaded', function () {
  const params = new URLSearchParams(window.location.search);
  const productUrl = params.get('product_url');
  const textarea = document.getElementById('ContactForm-body');

  if (productUrl && textarea && !textarea.value.trim()) {
    textarea.value = "I am enquiring about this product:\n" + decodeURIComponent(productUrl);
  }
});